import { useState, useEffect } from 'react';

function useDeviceDetection() {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      const hasTouch = 'ontouchstart' in window;
      setIsMobile(width < 768 || hasTouch);
    };
    
    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);
  
  return { isMobile, isDesktop: !isMobile };
}

export default useDeviceDetection;
